var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,1.98625,-2.0063)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17,-1,1,6.12323e-17,-1.98625,22.0088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "primaryColor",
    d: "M9.62,23.92C9.86,24.02 10.14,24.02 10.38,23.92C10.5,23.87 10.61,23.8 10.71,23.7L19.71,14.71C20.1,14.32 20.1,13.69 19.71,13.3C19.32,12.91 18.69,12.91 18.3,13.3L11.01,20.59L11.01,1C11.01,0.45 10.56,-0 10.01,-0C9.46,-0 9.01,0.45 9.01,1L9.01,20.59L1.72,13.3C1.33,12.91 0.7,12.91 0.31,13.3C0.11,13.5 0.02,13.75 0.02,14.01C0.02,14.27 0.12,14.52 0.31,14.72L9.31,23.72C9.4,23.81 9.51,23.89 9.64,23.94L9.62,23.92Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.2e41d75f39e1a70998a0fb16043830e0.svg";
export { ForwardRef as ReactComponent };